<section class="hero">
  <div class="hero-overlay">
    <h1>See if <span class="hero-express">Express</span><br />delivery is available</h1>
    <p class="hero-copy">
      Select your stores &amp; we'll see if your parcel qualifies for next business day delivery.
    </p>
    <p class="hero-copy hero-cutoff">Send by 3pm.</p>
  </div>
</section>

<section class="checker-wrap" aria-label="Delivery availability checker">
  <mat-card class="checker-card" appearance="outlined">
    <mat-card-header>
      <mat-card-title>Check Express availability</mat-card-title>
      <mat-card-subtitle>
        Choose from the stores below to check Express availability for this route  <br /><br />
        <span class="">*Available in selected stores only</span>
      </mat-card-subtitle>
      
    </mat-card-header>
    
    <hr />
    <mat-card-content>
      <div class="field-block">
        <div class="field-label">
          <label for="sending-store">From (Sending Store)</label>
          <!-- <button
            type="button"
            class="info-icon-button"
            aria-label="Sending store information"
            mat-icon-button
            matTooltip="Choose the store where the parcel will be sent from."
            matTooltipPosition="above"
            matTooltipTouchGestures="on"
            matTooltipShowDelay="0"
            matTooltipHideDelay="2500"
          >
            <mat-icon>info</mat-icon>
          </button> -->
        </div>
        <mat-form-field appearance="outline" subscriptSizing="dynamic">
          <mat-icon matPrefix [class.spin-loader]="loadingSendingStores">
            {{ loadingSendingStores ? 'autorenew' : 'location_on' }}
          </mat-icon>
          <input
            matInput
            id="sending-store"
            [formControl]="sendingStoreControl"
            placeholder="Select sending store"
            [matAutocomplete]="sendingStoreAuto"
          />
          @if (sendingStoreControl.value) {
            <button
              mat-icon-button
              matSuffix
              type="button"
              aria-label="Clear sending store"
              (click)="$event.stopPropagation(); clearSendingStore()"
            >
              <mat-icon>close</mat-icon>
            </button>
          }
          <mat-autocomplete
            #sendingStoreAuto="matAutocomplete"
            [displayWith]="displayStore"
            (optionSelected)="onSendingStoreSelected($event)"
          >
            @for (store of filteredSendingStores$ | async; track store.nodeIdNo) {
              <mat-option [value]="store">
                ({{ store.nodeCode }}) {{ store.nodeShortName }}
              </mat-option>
            }
          </mat-autocomplete>
        </mat-form-field>
      </div>

      <div class="field-block">
        <div class="field-label">
          <label for="collection-store">To (Collection Store)</label>
          <!-- <button
            type="button"
            class="info-icon-button"
            aria-label="Collection store information"
            mat-icon-button
            matTooltip="Choose the store where the parcel will be collected."
            matTooltipPosition="above"
            matTooltipTouchGestures="on"
            matTooltipShowDelay="0"
            matTooltipHideDelay="2500"
          >
            <mat-icon>info</mat-icon>
          </button> -->
        </div>
        <mat-form-field appearance="outline" subscriptSizing="dynamic">
          <mat-icon matPrefix [class.spin-loader]="loadingDestinations">
            {{ loadingDestinations ? 'autorenew' : 'location_on' }}
          </mat-icon>
          <input
            matInput
            id="collection-store"
            [formControl]="collectionStoreControl"
            placeholder="Select collection store"
            [matAutocomplete]="collectionStoreAuto"
          />
          @if (collectionStoreControl.value) {
            <button
              mat-icon-button
              matSuffix
              type="button"
              aria-label="Clear collection store"
              (click)="$event.stopPropagation(); clearCollectionStore()"
            >
              <mat-icon>close</mat-icon>
            </button>
          }
          <mat-autocomplete
            #collectionStoreAuto="matAutocomplete"
            [displayWith]="displayStore"
            (optionSelected)="onCollectionStoreSelected($event)"
          >
            @for (store of filteredCollectionStores$ | async; track store.nodeIdNo) {
              <mat-option [value]="store">
                ({{ store.nodeCode }}) {{ store.nodeShortName }}
              </mat-option>
            }
          </mat-autocomplete>
        </mat-form-field>
        <!-- <button mat-flat-button class="check-button" type="button" (click)="onCheckAvailability()">
          CHECK AVAILABILITY
        </button> -->
      </div>

      <!-- SUCCESS -->
      @if (showSuccessState()) {
        <div class="success-block">
          <div class="check-row">
            <mat-icon>check_circle</mat-icon>
            <p>
              Express available for sending at <strong>{{ selectedSendingStoreName() }}</strong>
            </p>
          </div>
          <div class="check-row">
            <mat-icon>check_circle</mat-icon>
            <p>
              Express available for collection at <strong>{{ selectedCollectionStoreName() }}</strong>
            </p>
          </div>
        </div>

        <div class="delivery-block">
          <mat-icon>calendar_month</mat-icon>
          <div>
            <p class="delivery-label">Estimated delivery</p>
            <p class="delivery-title">Next Business Day</p>
            <p class="delivery-copy">Send by 3pm today for next business day delivery.</p>
          </div>
        </div>

        <div class="cta-note">
          <mat-icon>shopping_bag</mat-icon>
          <div>
            <p class="cta-title">Ready to send?</p>
            <p>
              Buy a PAXI Express bag in-store or online &amp; drop it off at your chosen PAXI point by 3pm
            </p>
          </div>
        </div>
      }

      <!-- INVALID NODE QUERY PARAM -->
      @if (nodeParamErrorMessage) {
        <div class="error-block" role="status" aria-live="polite">
          <mat-icon>info</mat-icon>
          <div>
            <p class="error-title">Express unavailable</p>
            <p>
              {{ nodeParamErrorMessage }}
            </p>
          </div>
        </div>
      }

      <!-- ERROR -->
      @if (showErrorState()) {
        <div class="error-block" role="status" aria-live="polite">
          <mat-icon>info</mat-icon>
          <div>
            <p class="error-title">Express unavailable</p>
            <p>
              {{ selectedErrorMessage() }}
            </p>
          </div>
        </div>
      }
      @if (availabilityMessage) {
        <p class="availability-message">{{ availabilityMessage }}</p>
      }
    </mat-card-content>
  </mat-card>

  @if (showSuccessState()) {
    <!-- Result / Error States -->
    <div class="options-info">
      <div class="action-stack">
        <button
          mat-flat-button
          class="primary-action"
          type="button"
          routerLink="/"
          (click)="clearSendingStore()"
        >
          Find Another Route
        </button>
        <!-- <button mat-stroked-button class="secondary-action" type="button">
          VIEW PARTICIPATING STORES
        </button> -->
      </div>
    </div>
  }

  @if (showErrorState()) {
    <div class="options-info">
      <mat-card class="options-card" appearance="outlined">
        <mat-card-content>
          <h3>Other delivery options</h3>
          <div class="option-grid">
            <a
              class="option-item"
              href="https://www.paxi.co.za/paxi-for-you#Cost"
              target="_blank"
              rel="noopener noreferrer"
              (click)="onAlternativeServiceClick('speed')"
            >
              <mat-icon>speed</mat-icon>
              <div>
                <p class="option-title">Speed (3-5 days)</p>
                <p>Reliable delivery within 3 to 5 business days.</p>
              </div>
              <mat-icon class="arrow">chevron_right</mat-icon>
            </a>

            <a
              class="option-item"
              href="https://www.paxi.co.za/paxi-for-you#Cost"
              target="_blank"
              rel="noopener noreferrer"
              (click)="onAlternativeServiceClick('economy')"
            >
              <mat-icon>calendar_today</mat-icon>
              <div>
                <p class="option-title">Economy (7-9 days)</p>
                <p>Affordable delivery within 7 to 9 business days.</p>
              </div>
              <mat-icon class="arrow">chevron_right</mat-icon>
            </a>
          </div>
        </mat-card-content>
      </mat-card>
    </div>
  }
</section>
